import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _ from "lodash";
import { Container, Toast } from "react-bootstrap";
import SweetAlert from "react-bootstrap-sweetalert";
import { Prompt } from "react-router-dom";
import { Form, Button, Modal } from "react-bootstrap";

class FuseToast extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: null
    };
  }

  handleClose = () => {
    if (this.props?.onClose) this.props.onClose();
  };

  classes = () => {
    return [this.backgroundColorClasses(), "border-0", "align-middle", "font-weight-bold"].join(" ");
  };

  classesHeader = () => {
    return [this.backgroundColorClasses()].join(" ");
  };

  classesBody = () => {
    return ["py-3", "px-4", "font-weight-normal"].join(" ");
  };

  backgroundColorClasses = () => {
    switch (this.props.type) {
      case ToastTypes.INFO:
        return "bg-light";
      case ToastTypes.SUCCESS:
        return "bg-success";
      case ToastTypes.ERROR:
        return "bg-danger";
      case ToastTypes.WARNING:
        return "bg-warning";
      default:
        return "bg-secondary";
    }
  };

  iconType = () => {
    switch (this.props.type) {
      case ToastTypes.INFO:
        return "fa-info-circle";
      case ToastTypes.SUCCESS:
        return "fa-check-circle";
      case ToastTypes.ERROR:
        return " fa-times-circle";
      case ToastTypes.WARNING:
        return "fa-exclamation-triangle";
      default:
        return "";
    }
  };

  typeString = () => {
    switch (this.props.type) {
      case ToastTypes.INFO:
        return "Info Message";
      case ToastTypes.SUCCESS:
        return "Success Message";
      case ToastTypes.ERROR:
        return "Error Message";
      case ToastTypes.WARNING:
        return "Warning Message";
      default:
        return "";
    }
  };

  render() {
    return (
      <Toast
        show={this.props.isShowing}
        onClose={this.handleClose}
        animation={true}
        className={this.classes()}
        autohide={this.props.autohide === true}
        delay={this.props?.delay || 3000}
        style={{ maxWidth: "350px", minWidth: "350px" }}
      >
        <Toast.Header className={this.classesHeader()}>
          <i className={`fa ${this.iconType()} mr-3`} />
          <p className="mr-auto">{this.props?.title || ""}</p>
          {/* <small>{this.typeString()}</small> */}
        </Toast.Header>
        <Toast.Body className={this.classesBody()}>
          <p>{this.props?.text || ""}</p>
        </Toast.Body>
      </Toast>
    );
  }
}

FuseToast.propTypes = {
  isShowing: PropTypes.bool.isRequired,
  onClose: PropTypes.func,
  type: PropTypes.number,
  text: PropTypes.string,
  title: PropTypes.string,
  autohide: PropTypes.bool,
  delay: PropTypes.number
};

export const ToastTypes = Object.freeze({
  INFO: 0,
  SUCCESS: 1,
  ERROR: 2,
  WARNING: 3
});

export default FuseToast;
